import ServiceCard from '@/components/common/cards/service-card/ServiceCard';
import { BookingByGroups } from '@/components/common/forms/booking-datepicker-form-body/Groups';
import ParticipantsDataFormBody from '@/components/common/forms/participants-data-form-body/ParticipantsDataFormBody';
import { TiptapViewer } from '@/components/common/tiptap-viewer/TiptapViewer';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';
import { useFormLandingRange } from '@/hooks/business-logic/nb-landing/useFormLandingRange';
import { TOrganizationFAQ } from '@/services/api/organization-api';
import { Service } from '@/services/api/services-api';
import { Loader } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import PaymentStep from '../payment-step/PaymentStep';

type Props = {
  organization: TOrganizationFAQ;
  disabledDescription?: boolean;
  service: Service;
};

const NBLandingByRange = ({ organization, service }: Props) => {
  const { t } = useTranslation(['newBooking', 'common']);
  const {
    form,
    fields,
    isPendingSale,
    isSaleCreated,
    onSubmit,
    addParticipant,
    removeParticipant
  } = useFormLandingRange({
    service,
    organization
  });

  if (!service) {
    return null;
  }

  if (isSaleCreated) {
    return <PaymentStep organization={organization} />;
  }

  const isTiptapViewer = service.landing_page_content;

  return (
    <>
      {isTiptapViewer ? (
        <TiptapViewer
          content={service.landing_page_content}
          className="prose prose-lg max-w-none"
        />
      ) : (
        <ServiceCard service={service} organization={organization} />
      )}
      <Form {...form}>
        <form>
          {service && (
            <div className="flex flex-col gap-10">
              <BookingByGroups
                form={form}
                organization={organization}
                tz={organization.tz}
                service={service}
                isLanding
              />

              <ParticipantsDataFormBody
                form={form}
                service={service}
                fields={fields}
                organization={organization}
                isLanding
                addParticipant={addParticipant}
                removeParticipant={removeParticipant}
              />
              <Button
                type="button"
                className="w-full"
                onClick={onSubmit}
                disabled={isPendingSale}
              >
                {isPendingSale ? (
                  <Loader className="mr-2 h-4 w-4 animate-spin" />
                ) : (
                  t('stepParticipants.form.continue')
                )}
              </Button>
            </div>
          )}
        </form>
      </Form>
    </>
  );
};

export default NBLandingByRange;
